export default function Button(props: any) {
  return (
    <button className="btn btn-primary" {...props}>
      {props.children}
    </button>
  );
}
